import * as moment from 'moment';
import { Moment } from 'moment';

export class LocalLoadDocument {

  public id: string;
  public type: LocalLoadDocumentType;
  public shipmentNumber: string;
  public filename: string;
  public filesize: number;
  public uploadedAt: Moment;
  public uploadedBy: string;

  static fromDto(data: any): LocalLoadDocument {
    if (!data) {
      return null;
    }

    const document = new LocalLoadDocument();

    document.id             = data.id;
    document.type           = data.type;
    document.shipmentNumber = data.shipment_number;
    document.filename       = data.filename;
    document.filesize       = data.filesize;
    document.uploadedAt     = data.uploaded_at ? moment(data.uploaded_at) : null;
    document.uploadedBy     = data.uploaded_by;

    return document;
  }
}

export enum LocalLoadDocumentType {
  POD     = 'POD',
  PICTURE = 'PICTURE'
}
